import {EventEmitter, Injectable} from '@angular/core';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {take, takeUntil} from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {CommandService} from '@core/services/command.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {DialogService} from '@shared/services/dialog-service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {FileManagementService} from '@core/services/file-management.service';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PlatformToolRfpHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any>;

  constructor(private router: Router,
              public dialog: MatDialog,
              private commandService: CommandService,
              private snackBarService: SnackBarService,
              private dialogService: DialogService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private fileManagementService: FileManagementService) {}
  destroy(): void {
  }

  executeCommand(command: PlatformCommand, callBack?: any) {
    this.executeCommandToApi(command);
  }
  executeCommandToApi(command: PlatformCommand) {
    this.fuseSplashScreenService.show();
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
        this.fuseSplashScreenService.hide();
        if (commandResponse.fieldValues['RedirectCommand']) {
          this.executeCommand(commandResponse.fieldValues['RedirectCommand']);
          return;
        }
        if (commandResponse.fieldValues['RedirectUrl']) {
          this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']).then();
          return;
        }
        if (commandResponse.fieldValues['DownloadUrl'] && commandResponse.fieldValues['FileName']) {
          this.fileManagementService.downloadOneTimeSignedUrl(commandResponse.fieldValues['DownloadUrl'], commandResponse.fieldValues['FileName']);
          return;
        }
        if (commandResponse.fieldValues['DownloadFileId']) {
          const fileId = commandResponse.fieldValues['DownloadFileId'];
          const title = commandResponse.fieldValues['Title'];
          this.fileManagementService.downloadClientFileWithId(fileId).subscribe( payload => {
            this.fuseSplashScreenService.hide();
            this.fileManagementService.openSaveFileWindow(payload, `${title}`);
          });
          return;
        }
        this.invalidateSubject.invalidate();
      },
      error => {
        console.error('Failed ' + command.name, error);
        this.fuseSplashScreenService.hide();
      });
  }
  setSelectedTab(selectedTab: TabModel): void {
  }

  valueChanged($event) {
    if (this.handleAction($event)) {
      return;
    }
    if (this.handleNavigation($event)) {
      return;
    }
  }

  handleAction($event: any) {
    if ($event.action && $event.action.id) {
      const command = this.magicLinkModel.additionalCommands[$event.action.id];
      if (command) {
        command.fieldValues['ItemId'] = $event.item.id;
        this.executeCommandToApi(command);
        return true;
      }
    }
    if ($event.fieldDefinition && $event.fieldDefinition.key) {
      const fdKey = $event.fieldDefinition.key;
      const command = this.magicLinkModel.additionalCommands[fdKey];
      if (command) {
        command.fieldValues['ItemId'] = $event.item.id;
        this.executeCommandToApi(command);
        return true;
      }
    }
    return false;
  }
  handleNavigation($event: any): boolean {
    const navigationUrl = $event.item?.cells?.NavigationUrl?.value;
    if (!navigationUrl) {
      return false;
    }

    const isOpenAction = $event.action?.id === 'Open';
    const isHyperlinkViewer = $event.fieldDefinition?.cellViewer === 'HyperlinkCellViewerComponent';
    if (isOpenAction || isHyperlinkViewer) {
      this.router.navigateByUrl(navigationUrl);
      return true;
    }
    return false;
  }
}
